<section class="left">
  <div #leftDiv (scroll)="handleScrollLeft()">
    <ng-content select="[slot='left']"></ng-content>
  </div>
</section>

<section class="right">
  <div #rightDiv (scroll)="handleScrollRight()">
    <ng-content select="[slot='right']"></ng-content>
  </div>
</section>
